document.addEventListener("DOMContentLoaded", function() {
    var btnBurger = document.querySelector('#mobile-toggle');
    var mainNav = document.querySelector('.main-nav');
    var body = document.body;

    // Clone main nav to use as mobile nav
    var clonedNav = mainNav.cloneNode(true);
    clonedNav.classList.add("cloned-nav"); // Add new class to cloned nav

    // Remove btnBurger from cloned nav
    var clonedBtnBurger = clonedNav.querySelector('#mobile-toggle');
    if (clonedBtnBurger) {
        clonedBtnBurger.remove();
    }

    // Remove header logo from cloned nav
    var clonedLogoHeader = clonedNav.querySelector('.main-nav_wrapper-logo-header');
    if (clonedLogoHeader) {
        clonedLogoHeader.remove(); 
    }

    // Add SVG to the end of the clonedNav
    const svgCut = `
    <svg class="svg-cut" xmlns="http://www.w3.org/2000/svg" width="766.874" height="348.445" viewBox="0 0 766.874 348.445">
        <path id="Path_10646" data-name="Path 10646" d="M-5438.169,5699.591v146.082l417.666,94.884v28.821l349.208,78.658V5699.591Z" transform="translate(5438.169 -5699.591)" fill="#e11936"/>
    </svg>
    `;  

    // Insere o SVG no final do clonedNav
    clonedNav.insertAdjacentHTML('beforeend', svgCut);

    // Add cloned nav to body
    body.appendChild(clonedNav);


    btnBurger.addEventListener('click', function() {
        clonedNav.classList.toggle("open");
        body.classList.toggle("no-scroll"); // Prevent scrolling when menu is open
        btnBurger.classList.toggle('active'); // Add animation to burger icon
    });

    window.addEventListener('resize', function() {
        if (window.innerWidth > 767) {
            clonedNav.classList.remove('open');
            btnBurger.classList.remove('active');
            body.classList.remove('no-scroll');
        }
    });
});
